import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_PARTNER_CATEGORIES, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_PARTNER_CATEGORY, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    return res
  })
}

export const destroy = async ({ commit }, id) => {
  await services.destroy(id).then(res => {
    return res
  })
}
